import React from "react";
import { motion } from "framer-motion";
import "../components/TermsConditions.css";
import termsImg1 from "../Assets/terms-and-conditions.png";
import TermsBanner from "../components/TermsBanner";

const TermsConditions = () => {
  return (
    <>
      {/* Banner Section with Animation */}
      <motion.div
        initial={{ opacity: 0, y: -50 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
      >
        <TermsBanner />
      </motion.div>

      {/* Main Terms Page Content */}
      <div className="tc-page-container">
        {/* SECTION A–C */}
        <section className="tc-section tc-section-main">
          <div className="tc-text-block tc-left">
            <h2 className="tc-title">Terms & Conditions</h2>

            <p className="tc-description">
              <strong style={{ color: "black" }}>A.</strong> This document is an
              electronic record in terms of Information Technology Act, 2000 and
              rules there under as applicable and the amended provisions pertaining
              to electronic records in various statutes as amended by the
              Information Technology Act, 2000. This electronic record is generated
              by a computer system and does not require any physical or digital
              signatures.
            </p>

            <p className="tc-description">
              <strong style={{ color: "black" }}>B.</strong> This document is
              published in accordance with the provisions of Rule 3 (1) of the
              Information Technology (Intermediaries guidelines) Rules, 2011 that
              require publishing the rules and regulations, privacy policy and
              Terms of Use for access or usage of domain name
              <strong> newzealacademy.com </strong>(“Website”), including the
              related mobile site and mobile application (hereinafter referred to
              as “Platform”).
            </p>

            <p className="tc-description">
              <strong style={{ color: "black" }}>C.</strong> The Platform is owned
              by <strong>NEWZEAL LANGUAGE ACADEMY</strong>, a company incorporated
              under the Companies Act, 1956 with its registered office at 43A 19th
              D Main First Block Rajajinagar, Bangalore, India (hereinafter
              referred to as “Platform Owner”, “we”, “us”, “our”).
            </p>
          </div>

          <div className="tc-image-block tc-right">
            <img src={termsImg1} alt="Terms Illustration" className="tc-image" />
          </div>
        </section>

        {/* SECTION D */}
        <section className="tc-section tc-single">
          <div className="tc-single-content">
            <p className="tc-description">
              <strong style={{ color: "black" }}>D.</strong> Your use of the
              Platform and services and tools are governed by the following terms
              and conditions (“Terms of Use”) as applicable to the Platform,
              including the applicable policies which are incorporated herein by
              way of reference. If You transact on the Platform, You shall be
              subject to the policies that are applicable to the Platform for such
              transaction. By mere use of the Platform, You shall be contracting
              with the Platform Owner and these terms and conditions including the
              policies constitute Your binding obligations with the Platform Owner.
              These Terms of Use relate to your use of our website, goods, or
              services (collectively, “Services”). Any terms and conditions
              proposed by You which are in addition to or conflict with these Terms
              of Use are expressly rejected. These Terms of Use can be modified at
              any time without assigning any reason. It is your responsibility to
              periodically review these Terms of Use to stay informed of updates.
            </p>
          </div>
        </section>

        {/* SECTION E */}
        <section className="tc-section tc-single">
          <div className="tc-single-content">
            <p className="tc-description">
              <strong style={{ color: "black" }}>E.</strong> For the purpose of
              these Terms of Use, wherever the context so requires “you”, “your” or
              “user” shall mean any natural or legal person who has agreed to
              become a user/buyer on the Platform.
            </p>
          </div>
        </section>

        {/* SECTION F */}
        <section className="tc-section tc-single">
          <div className="tc-single-content">
            <p className="tc-description">
              <strong style={{ color: "black" }}>F.</strong> ACCESSING, BROWSING,
              OR OTHERWISE USING THE PLATFORM INDICATES YOUR AGREEMENT TO ALL THE
              TERMS AND CONDITIONS UNDER THESE TERMS OF USE. PLEASE READ THEM
              CAREFULLY BEFORE PROCEEDING.
            </p>
          </div>
        </section>

        {/* SECTION G WITH LIST */}
        <section className=" tc-single">
          <div className="tc-single-content">
            <p className="tc-description">
              <strong style={{ color: "black" }}>G.</strong> The use of Platform
              and/or availing of our Services is subject to the following Terms of
              Use:
            </p>

            <ul className="tc-points-list">
              <li>
                To access and use the Services, you agree to provide true, accurate,
                and complete information to us during and after registration.
              </li>
              <li>
                Neither we nor any third parties provide any warranty or guarantee
                as to the accuracy, performance, or suitability of the information
                provided.
              </li>
              <li>
                Your use of our Services and the Platform is solely at your own
                risk. You are required to ensure that the Services meet your
                requirements.
              </li>
              <li>
                The contents of the Platform are proprietary and licensed to us. You
                may not claim any intellectual property rights over them.
              </li>
              <li>
                Unauthorized use of the Platform and/or the Services may lead to
                action against you as per these Terms and applicable laws.
              </li>
              <li>You agree to pay us the charges associated with availing the Services.</li>
              <li>
                You agree not to use the Platform or Services for unlawful or
                prohibited purposes.
              </li>
              <li>
                The website may contain links to third-party sites; upon accessing
                them, you’ll be governed by their respective terms and policies.
              </li>
              <li>
                Upon initiating a transaction, you enter a legally binding contract
                with the Platform Owner.
              </li>
              <li>
                You shall indemnify and hold harmless the Platform Owner and its
                affiliates from any claims arising out of your breach of these
                Terms.
              </li>
              <li>
                The parties shall not be liable for any failure to perform
                obligations if prevented by a force majeure event.
              </li>
              <li>
                These Terms are governed by the laws of India. All disputes shall be
                subject to the exclusive jurisdiction of the courts in{" "}
                <strong>Bangalore, Karnataka</strong>.
              </li>
              <li>
                All concerns or communications relating to these Terms must be
                directed to us using the contact information provided on this
                website.
              </li>
            </ul>
          </div>
        </section>
      </div>
    </>
  );
};

export default TermsConditions;
